import FormElement from "../formElement";

export default class ElementsTemplate extends FormElement {

  get controlName(): string {
    return this.label_title;
  }

  get controlIcon(): string {
    return 'icon puzzle-piece';
  }
}
